import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 32 32" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 16C0 7.16344 7.16344 0 16 0V0C24.8366 0 32 7.16344 32 16V16C32 24.8366 24.8366 32 16 32V32C7.16344 32 0 24.8366 0 16V16Z",
      fill: "#EDEFF1"
    }, null, -1),
    _createElementVNode("path", {
      d: "M21.2184 24.3599C20.3581 24.3599 19.595 23.8118 19.3314 23.0001L18.367 20.0725H13.5593L12.6644 22.9724C12.3938 23.8049 11.6307 24.3599 10.7635 24.3599C10.5554 24.3599 10.3473 24.3252 10.1461 24.2627C9.11238 23.9506 8.52269 22.8336 8.83488 21.7791L12.9003 8.91692C13.1639 8.0983 13.9409 7.52942 14.7873 7.52942H16.9448C17.7982 7.52942 18.5752 8.09136 18.8319 8.89611L23.0984 21.7514C23.4384 22.7989 22.8764 23.9297 21.8358 24.2697C21.6416 24.3252 21.4265 24.3599 21.2184 24.3599Z",
      fill: "#0F171F"
    }, null, -1)
  ])))
}
export default { render: render }